import LockPaywall from './LockPaywall';

export default LockPaywall;
